import React from 'react';
import { useTranslation } from 'react-i18next';
import AppShellLayout from '../components/AppShellLayout';
import { IconFileText, IconUsers, IconZap, IconSettings } from '../components/Icons';

const iconMap: Record<string, React.ReactNode> = {
  Invoices:            <IconFileText size={22} />,
  'Accounts & Services': <IconUsers size={22} />,
  'Auto-responses':    <IconZap size={22} />,
  Settings:            <IconSettings size={22} />,
};

export default function PlaceholderPage({ title }: { title: string }) {
  const { t } = useTranslation();

  return (
    <AppShellLayout>
      <div className="page-header">
        <h1>{title}</h1>
      </div>
      <div className="placeholder-card">
        <div className="placeholder-icon">
          {iconMap[title] ?? <IconFileText size={22} />}
        </div>
        <p>{t('placeholder.comingSoonBody')}</p>
      </div>
    </AppShellLayout>
  );
}
